exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_object-pie.js
// module id = 72
// module chunks = 1